module.exports = __webpack_public_path__ + "img/filipbasara_gabee_interface_3_mock.9800aae6.jpg";